import { callExternalApi } from './external-api.service'
import PLAID_API_PATHS from '../constants/PLAID_API_PATHS';

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

export const generateFetchHeaders = (auth0Token) => {
    const fetchHeaders = {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${auth0Token}`,
    };

    return fetchHeaders
};

export const svc_plaid_createLinkToken = async (auth0Token, userId) => {
    const headers = generateFetchHeaders(auth0Token);
    
    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.CREATE_LINK_TOKEN()}`,
        data: { userId },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_exchangePublicToken = async (auth0Token, publicToken, userId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.EXCHANGE_PUBLIC_TOKEN()}`,
        data: { public_token: publicToken, userId: userId },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_getAccounts = async (auth0Token, userId, itemId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.GET_ACCOUNTS()}`,
        data: {
            userId,
            itemId,
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_getAccountBalances = async (auth0Token, userId, itemId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.GET_ACCOUNT_BALANCES()}`,
        data: {
            userId,
            itemId,
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_getLiabilities = async (auth0Token, userId, itemId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.GET_LIABILITIES()}`,
        data: {
            userId,
            itemId,
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_getTransactions = async (auth0Token, userId, itemId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.GET_TRANSACTIONS()}`,
        data: {
            userId,
            itemId,
        },
        method: 'POST',
        headers: headers,
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_plaid_getInstitutionById = async (auth0Token, institutionId) => {
    const headers = generateFetchHeaders(auth0Token);

    const config = {
        url: `${apiServerUrl}${PLAID_API_PATHS.GET_INSTITUTION_BY_ID()}`,
        method: 'POST',
        headers: headers,
        data: { institution_id: institutionId },
        mode: 'cors'
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}